const DIRECTIONS = {
  RIGHT: 'right',
  LEFT: 'left',
  UP: 'up',
  DOWN: 'down',
};

const SIZES = {
  SMALL: 4,
  MEDIUM: 6,
  LARGE: 9,
  EXTRA_LARGE: 12,
};

export { DIRECTIONS, SIZES };
